/* eslint-disable no-unused-vars */
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import axios from "axios";
const SERVER_URL = process.env.REACT_APP_SERVER_URL


const Navbar = () => {
  const [show, setShow] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("userTokenTime")
  );

  const signoutHandler = () => {
    const cart_Products =
      JSON.parse(localStorage.getItem("productsInCart")) || [];
    const token = JSON.parse(localStorage.getItem("userTokenTime")).token;
    localStorage.removeItem("userTokenTime");
    localStorage.removeItem("productsInCart");
    localStorage.removeItem("role");

    axios
      .post(
        SERVER_URL+
        "/api/signout",
        {
          cart: cart_Products,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        console.log("signed out successfully!");
        window.location = process.env.REACT_APP_LINK
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const searchEvent = (e)=>{
    e.prevent.default();
    window.location = process.env.REACT_APP_LINK;
  }

  const dispatch = useDispatch();
  let val = "";
  const { cartProducts } = useSelector((state) => state.cartReducer);
  console.log(cartProducts);
  const [cartPro, setCartPro] = useState(cartProducts);

  return (
    <>
      <nav className="navbar navbar-expand-lg nav navbar-light bg-light">
        <Link to="/">
          <h3 className="icon">ST🌐RE</h3>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">

          <ul className="navbar-nav mr-auto mobile-nav" style={{paddingTop:"0"}}>
            <Link to="/products/category/men">
              <li className="nav-item">MEN</li>
            </Link>

            <Link to="/products/category/women">
              <li className="nav-item">WOMEN</li>
            </Link>
            <Link to="/products/category/kids">
              <li className="nav-item">KIDS</li>
            </Link>
          </ul>

          <form
          onSubmit={(e)=>searchEvent(e)}
          className="form-inline w-50 mx-auto my-2 my-lg-0">
            <input
              className="form-control w-100 mr-sm-2 mobile-input"
              name="search"
              type="text"
              placeholder="Search for products, brands and more"
              aria-label="Search"
              onChange={(e)=>setSearchText(e.target.value)}
              style={{background:"#F5F5F6"}}
            />
            <input type="submit" hidden />

          </form>

            <div className="header__right ml-auto" style={{ display: "flex", alignItems: "center" }}>
              <div className="mx-5 dropdown" style={{boxShadow: "0 1px 10px rgb(0 0 0 / 8%)"}}>
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{cursor:"pointer"}}
                >
                  <i class="fa fa-user"></i>
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                  show={show}
                  onMouseEnter={()=>setShow(true)} 
                  onMouseLeave={()=>setShow(false)}
                >
                  <Link to="/Orders">
                    <div className="dropdown-item">
                      Profile
                    </div>
                  </Link>
                  <Link to="/Orders">
                    <div className="dropdown-item">
                      Orders
                    </div>
                  </Link>
                  <Link to="/Orders">
                    <div className="dropdown-item">
                      Wishlist
                    </div>
                  </Link>

                  {!localStorage.getItem("userTokenTime") ? (
                    <>
                      <Link to="/signin">
                        <div className="dropdown-item">Login / Signup</div>
                      </Link>
                    </>
                  ) : (
                    <div className="dropdown-item" onClick={signoutHandler}>
                      Sign Out
                    </div>
                  )}


                </div>
              </div>
              <Link to="/">
                <div className="cartdiv" style={{marginRight:"1.50rem"}}>
                  <i
                    className="fa fa-heart"
                    aria-hidden="true"
                  ></i>
                </div>
              </Link>
              <Link to="/cart">
                <div className="cartdiv">
                  <i
                    className="fa fa-shopping-cart carticon"
                    aria-hidden="true"
                  ></i>
                  <span className="item-circle">{cartProducts.length}</span>
                </div>
              </Link>
            </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
